<template>
  <div class="login-bg">
    <div class="login">
      <div class="login-header">
        <!--慧执法-后台管理系统-->
        <img v-if="hostSec === 'pucha'" src="../assets/login_logo_pucha.png" />
        <img v-else src="../assets/login_logo.png" />
      </div>

      <el-form class="login_form" :model="loginForm" status-icon :rules="loginRules" ref="loginForm">
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" size="small" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" v-model="loginForm.password" size="small" placeholder="请输入密码" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-row>
            <el-col :span="16">
              <el-input class="code_input" v-model="loginForm.code" size="small" placeholder="图形验证码" autocomplete="off"></el-input>
            </el-col>
            <el-col :span="8">
              <div style="position: relative; height: 30px;margin-left: 10px;margin-top: 5px;float: left;border-radius: 5px">
                <img src="" alt=" " v-if="netError" height="30" width="98%" />
                <canvas height="30" width="98%" id="c1" style="border-radius: 5px" ref="c1" v-else> </canvas>

                <div style="position: absolute;top:-5px;right: -94px;color:#fff;cursor: pointer;" @click="paintVeffyCode">
                  <i class="el-icon-refresh-right"></i>
                  <span>换个验证码</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item prop="checked">
          <el-checkbox v-model="loginForm.checked" style="color: #ffffff">记住密码</el-checkbox>
        </el-form-item>

        <el-form-item>
          <el-button class="btn-width" type="primary" native-type="submit" size="small" @click.native.prevent="enterIn('loginForm')" :loading="loading">
            登 录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { LoginIn } from "../api/module/login"
import Cookies from "js-cookie"
import { mapState } from "vuex"
import { apiBaseURL } from "../utils/global"
import { getHostSecond } from "@/utils/utils"

export default {
  data() {
    return {
      hostSec: getHostSecond(),
      // fullscreenLoading:true,
      netError: false,
      codeurl: apiBaseURL,
      loading: false,
      loginForm: {
        password: "",
        username: "",
        code: "",
        checked: false
      },
      loginRules: {
        password: [{ required: true, message: "请输入登录密码", trigger: "blur" }],
        username: [{ required: true, message: "用户名不可为空", trigger: "blur" }],
        code: [{ required: true, message: "验证码不可为空", trigger: "blur" }]
      },
      coderUrl: "",
      unCompleteMsg: this.global.unCompleteMsg
    }
  },
  computed: {
    ...mapState(["logInfo"])
  },
  methods: {
    openWin(){
      this.$confirm('慧执法APP（现场检查）管理系统已经转移到重庆市农业综合行政执法“慧执法”平台中；请大家转移到新系统进行使用及操作，老系统依旧可以使用，但是不再提供运维服务，如有问题即时询问管理员。', '提示', {
        distinguishCancelAndClose: true,
        showCancelButton: false,
        confirmButtonText: '确定',
      })
      .then(() => {
        // window.location.href = 'http://ba.nyzf.cloud/'
      })
      .catch(action => {

      });

    },
    enterIn(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true
          const userInfo = {
            loginName: this.loginForm.username,
            loginPwd: this.loginForm.password,
            code: this.loginForm.code
          }
          this.$store.commit("toggleError", false)
          LoginIn(
            userInfo,
            res => {
              // this.fullscreenLoading = false;
              // 记住密码操作
              const loginInfo = {}
              if (this.loginForm.checked) {
                loginInfo.username = this.loginForm.username
                loginInfo.password = this.loginForm.password
                loginInfo.checked = this.loginForm.checked
                Cookies.set("reLoginInfo", JSON.stringify(loginInfo))
              } else {
                Cookies.remove("reLoginInfo") // 删除cookie
              }

              const logerInfo = res.obj
              // 5-20   登录信息保存到缓存中
              Cookies.set("user", logerInfo)

              sessionStorage.setItem("loginUser", JSON.stringify(logerInfo)) // 关闭窗口后，登录信息不在
              // 将登陆信息保存到vuex
              this.$store.dispatch("recordLogInfo", logerInfo)
              // this.$router.push({ path: '/home' });
              this.$router.push({ path: "/homeStopOver" })
              Cookies.remove("hzfadminimagecode")
            },
            () => {
              // console.log(res);

              // this.getCoder();
              this.paintVeffyCode()
              this.loginForm.code = ""
              this.loading = false
            }
          )
        } else {
          this.$message({
            message: this.unCompleteMsg,
            type: "error"
          })
          return false
        }
      })
    },

    // 前台画的验证码
    paintVeffyCode() {
      if (Cookies.get("hzfadminimagecode")) {
        Cookies.remove("hzfadminimagecode")
      }
      this.$http.post(
        "zuul-login/zuul/common/imageCodeInfo",
        null,
        res => {
          this.netError = false
          // const data = resData.obj;
          const data = res.obj
          const w = this.$refs.c1.offsetWidth
          const h = 30
          const ctx = c1.getContext("2d")
          // 清空画布
          ctx.clearRect(0, 0, w, h)
          // 1.新建一个函数产生随机数
          function rn(min, max) {
            return parseInt(Math.random() * (max - min) + min)
          }
          // 2.新建一个函数产生随机颜色
          function rc(min, max) {
            const r = rn(min, max)
            const g = rn(min, max)
            const b = rn(min, max)
            return `rgb(${r},${g},${b})`
          }
          // 3.填充背景颜色,颜色要浅一点*/
          ctx.fillStyle = "white"
          ctx.fillRect(0, 0, w, h)
          // 4.随机产生字符串
          for (let i = 0; i < data.length; i++) {
            const c = data.charAt(i)
            const fs = rn(30, 40) // 字体的大小
            const deg = rn(-30, 30) // 字体的旋转角度
            ctx.font = `${fs}px Simhei`
            ctx.textBaseline = "top"
            ctx.fillStyle = rc(60, 150)
            ctx.save()
            ctx.translate(20 * i + 15, 15)
            ctx.rotate((deg * Math.PI) / 180)
            ctx.fillText(c, -15 + 5, -15)
            ctx.restore()
          }

          // 5.随机产生5条干扰线,干扰线的颜色要浅一点
          for (let i = 0; i < 6; i++) {
            ctx.beginPath()
            ctx.moveTo(rn(0, w), rn(0, h))
            ctx.lineTo(rn(0, w), rn(0, h))
            ctx.strokeStyle = rc(180, 230)
            ctx.closePath()
            ctx.stroke()
          }
          // 6.随机产生40个干扰的小点
          for (let i = 0; i < 10; i++) {
            ctx.beginPath()
            ctx.arc(rn(0, w), rn(0, h), 1, 0, 2 * Math.PI)
            ctx.closePath()
            ctx.fillStyle = rc(150, 200)
            ctx.fill()
          }
        },
        res => {
          // console.log(res);
          if (res == "Network Error") {
            this.netError = true
          }
        }
      )
    },
    clearInfos() {
      sessionStorage.setItem("store", null) // session置空
      sessionStorage.removeItem("HEARDTOKENID")
      this.$store.commit("resetLoad", false)
      this.$store.commit("updateMainTabs", [])
    }
  },
  created() {
    this.openWin()
    const loginInfo = Cookies.get("reLoginInfo")
    if (loginInfo) {
      const t = JSON.parse(loginInfo)
      this.loginForm.username = t.username
      this.loginForm.password = t.password
      this.loginForm.checked = t.checked
    }
  },
  mounted() {
    this.paintVeffyCode()
    this.clearInfos()
  }
}
</script>
<style scoped>
.login-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url("../assets/3.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.login {
  width: 900px;
  height: 300px;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -450px;
  margin-top: -250px;
}

.btn-width {
  width: 100%;
  background: #d14e17;
  border-color: #d14e17;
  font-size: 14px;
}

.login-header {
  text-align: center;
  font-size: 1.8em;
  color: #ffffff;
  font-weight: 400;
  margin-bottom: 10px;
}
.login-header img {
  width: 480px;
}

.login_form {
  width: 320px;
  margin: 0 auto;
  padding: 10px 20px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.el-form-item {
  margin-bottom: 12px;
}
.login_form >>> .el-form-item__error {
  padding-top: 1px;
  font-size: 9px;
}

.login_form >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #ffffff;
}
</style>
